<template>
  <SidebarModal :showModal="show" :maxWidth="'480px'" @close="onClose">
    <div class="tags-category-share-modal">
      <div class="tags-category-share-modal__title">
        <h2 class="tags-category-share-modal__title-modal">הגדרת גישה</h2>
        <div class="tags-category-share-modal__sub-title">
          {{ modalTitle }}
        </div>
      </div>

      <div class="tags-category-share-modal__toolbar">
        <span class="tags-category-share-modal__toolbar-title">אישית</span>
        <span class="tags-category-share-modal__counter" aria-hidden="true">{{
          membersCountDisplay
        }}</span>
      </div>

      <WorkerCampusSingleSelect
        v-model="selectedWorkerUserId"
        :campus-id="campusId"
        :placeholder="'בחר עובד'"
        :open-direction="'bottom'"
        :disabled="isSharingLoading || isSavingShare"
        @pick="onWorkerPicked"
      />

      <div
        v-if="ownerRow || sharedTeachers.length"
        class="tags-category-share-modal__members"
      >
        <div
          v-if="ownerRow"
          class="
            tags-category-share-modal__member
            tags-category-share-modal__member--owner
          "
        >
          <div class="tags-category-share-modal__member-main">
            <img
              v-if="ownerRow.image_path"
              :src="ownerRow.image_path"
              alt=""
              class="tags-category-share-modal__avatar"
              v-avatar-placeholder
            />
            <div
              v-else
              class="
                tags-category-share-modal__avatar
                tags-category-share-modal__avatar--empty
              "
            />
            <span class="tags-category-share-modal__name">{{
              ownerRow.label
            }}</span>
          </div>
          <span class="tags-category-share-modal__owner-badge">יוצר</span>
        </div>

        <div
          v-for="row in sharedTeachers"
          :key="row.userId"
          class="tags-category-share-modal__member"
        >
          <div class="tags-category-share-modal__member-main">
            <img
              v-if="row.image_path"
              :src="row.image_path"
              alt=""
              class="tags-category-share-modal__avatar"
              v-avatar-placeholder
            />
            <div
              v-else
              class="
                tags-category-share-modal__avatar
                tags-category-share-modal__avatar--empty
              "
            />
            <span class="tags-category-share-modal__name">{{ row.label }}</span>
          </div>
          <div class="tags-category-share-modal__member-actions">
            <div
              class="tags-category-share-modal__perm"
              :class="{
                'tags-category-share-modal__perm--open':
                  permMenuOpenUserId === row.userId
              }"
              dir="rtl"
              v-click-outside="closePermMenu"
            >
              <button
                type="button"
                class="tags-category-share-modal__perm-trigger"
                :aria-expanded="permMenuOpenUserId === row.userId"
                :disabled="isSharingLoading || isSavingShare"
                @click.stop="togglePermMenu(row.userId)"
              >
                <span class="tags-category-share-modal__perm-trigger-text">{{
                  permissionLabel(row.permission)
                }}</span>
                <span
                  class="tags-category-share-modal__perm-chevron"
                  :class="{
                    'tags-category-share-modal__perm-chevron--open':
                      permMenuOpenUserId === row.userId
                  }"
                  aria-hidden="true"
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 4.5L6 7.5L9 4.5"
                      stroke="#5B7299"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </button>
              <div
                v-show="permMenuOpenUserId === row.userId"
                class="tags-category-share-modal__perm-panel"
                role="listbox"
              >
                <button
                  type="button"
                  role="option"
                  class="tags-category-share-modal__perm-option"
                  :class="{
                    'tags-category-share-modal__perm-option--active':
                      row.permission === 'view'
                  }"
                  @click.stop="pickPermission(row.userId, 'view')"
                >
                  צפייה
                </button>
                <button
                  type="button"
                  role="option"
                  class="tags-category-share-modal__perm-option"
                  :class="{
                    'tags-category-share-modal__perm-option--active':
                      row.permission === 'edit'
                  }"
                  @click.stop="pickPermission(row.userId, 'edit')"
                >
                  עריכה
                </button>
              </div>
            </div>
            <button
              type="button"
              class="tags-category-share-modal__remove"
              title="הסר"
              :disabled="isSharingLoading || isSavingShare"
              @click="removeShared(row.userId)"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.33203 5.83335H16.6654M7.14156 5.83351V4C7.14156 3.60218 7.29207 3.22064 7.55997 2.93934C7.82788 2.65804 8.19125 2.5 8.57013 2.5H11.4273C11.8061 2.5 12.1695 2.65804 12.4374 2.93934C12.7053 3.22064 12.8558 3.60218 12.8558 4V5.83351M8.33203 9.16668V14.1667M11.6654 9.16668V14.1667M14.9987 5.83351V16C14.9987 16.3978 14.8482 16.7794 14.5803 17.0607C14.3124 17.342 13.949 17.5 13.5701 17.5H6.42727C6.04839 17.5 5.68503 17.342 5.41712 17.0607C5.14921 16.7794 4.9987 16.3978 4.9987 16V5.83351H14.9987Z"
                  stroke="#FF6052"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div class="tags-category-share-modal__all-workers">
        <div class="tags-category-share-modal__all-workers-title">
          לכל העובדים
        </div>
        <div
          class="tags-category-share-modal__all-workers-bar"
          dir="rtl"
          role="radiogroup"
          aria-label="לכל העובדים"
        >
          <button
            type="button"
            role="radio"
            :aria-checked="allWorkersAccess === 'none'"
            class="tags-category-share-modal__all-workers-seg"
            :class="{
              'tags-category-share-modal__all-workers-seg--active':
                allWorkersAccess === 'none'
            }"
            :disabled="isSharingLoading || isSavingShare"
            @click="allWorkersAccess = 'none'"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 9V5.88889C6 4.85749 6.42143 3.86834 7.17157 3.13903C7.92172 2.40972 8.93913 2 10 2C11.0609 2 12.0783 2.40972 12.8284 3.13903C13.5786 3.86834 14 4.85749 14 5.88889V9M4.55556 9H15.4444C16.3036 9 17 9.73263 17 10.6364V16.3636C17 17.2674 16.3036 18 15.4444 18H4.55556C3.69645 18 3 17.2674 3 16.3636V10.6364C3 9.73263 3.69645 9 4.55556 9Z"
                stroke="#5A6F95"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <span>אין גישה</span>
          </button>
          <button
            type="button"
            role="radio"
            :aria-checked="allWorkersAccess === 'view'"
            class="tags-category-share-modal__all-workers-seg"
            :class="{
              'tags-category-share-modal__all-workers-seg--active':
                allWorkersAccess === 'view'
            }"
            :disabled="isSharingLoading || isSavingShare"
            @click="allWorkersAccess = 'view'"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.0013 15C14.6037 15 18.3346 10 18.3346 10C18.3346 10 14.6037 5 10.0013 5C5.39893 5 1.66797 10 1.66797 10C1.66797 10 5.39893 15 10.0013 15Z"
                stroke="#5A6F95"
                stroke-width="2"
                stroke-linejoin="round"
              />
              <path
                d="M10.0013 12.5C11.382 12.5 12.5013 11.3807 12.5013 10C12.5013 8.61929 11.382 7.5 10.0013 7.5C8.62059 7.5 7.5013 8.61929 7.5013 10C7.5013 11.3807 8.62059 12.5 10.0013 12.5Z"
                stroke="#5A6F95"
                stroke-width="2"
                stroke-linejoin="round"
              />
            </svg>

            <span>צפייה</span>
          </button>
          <button
            type="button"
            role="radio"
            :aria-checked="allWorkersAccess === 'edit'"
            class="tags-category-share-modal__all-workers-seg"
            :class="{
              'tags-category-share-modal__all-workers-seg--active':
                allWorkersAccess === 'edit'
            }"
            :disabled="isSharingLoading || isSavingShare"
            @click="allWorkersAccess = 'edit'"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.8473 3.1267C14.046 2.92801 14.2819 2.7704 14.5415 2.66287C14.8011 2.55534 15.0793 2.5 15.3603 2.5C15.6413 2.5 15.9195 2.55534 16.1791 2.66287C16.4387 2.7704 16.6746 2.92801 16.8733 3.1267C17.072 3.32538 17.2296 3.56126 17.3371 3.82086C17.4447 4.08045 17.5 4.35869 17.5 4.63968C17.5 4.92066 17.4447 5.1989 17.3371 5.45849C17.2296 5.71809 17.072 5.95397 16.8733 6.15266L6.66069 16.3653L2.5 17.5L3.63473 13.3393L13.8473 3.1267Z"
                stroke="#5A6F95"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <span>עריכה</span>
          </button>
        </div>
      </div>

      <div class="tags-category-share-modal__footer">
        <button
          type="button"
          class="tags-category-share-modal__save"
          :disabled="isSavingShare || categoryApiId == null"
          @click="onSaveShare"
        >
          <span class="tags-category-share-modal__save-text">שמור</span>
          <svg
            class="tags-category-share-modal__save-disk"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17 21v-8H7v8M7 3v5h8"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  </SidebarModal>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import SidebarModal from '@/Components/UI/SidebarModal/SidebarModal.vue';
import WorkerCampusSingleSelect from '@/Components/UI/Form/WorkerCampusSingleSelect.vue';

export default {
  name: 'TagsCategoryShareModal',
  components: {
    SidebarModal,
    WorkerCampusSingleSelect
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    category: {
      type: Object,
      default: null
    },
    campusId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      selectedWorkerUserId: null,
      sharedTeachers: [],
      /** user_id из последнего GET — для PATCH с access_level 0 при удалении */
      sharingUserIdsInitiallyLoaded: [],
      permMenuOpenUserId: null,
      allWorkersAccess: 'none',
      isSharingLoading: false,
      isSavingShare: false
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    }),
    modalTitle() {
      const c = this.category;
      const name =
        c && c.label != null && String(c.label).trim()
          ? String(c.label).trim()
          : '';
      if (name) {
        return name;
      }
      return 'שיתוף קטגוריה';
    },
    ownerRow() {
      const u = this.currentUser;
      if (!u || u.id == null) {
        return null;
      }
      const label = [u.name, u.last_name].filter(Boolean).join(' ').trim();
      return {
        userId: u.id,
        label: label || u.email || '—',
        image_path: u.image_path || u.img || null
      };
    },
    membersCountDisplay() {
      const n = (this.ownerRow ? 1 : 0) + this.sharedTeachers.length;
      return String(n);
    },
    categoryApiId() {
      const c = this.category;
      if (!c) {
        return null;
      }
      const raw = c.apiId != null ? c.apiId : c.id;
      if (raw == null || raw === '' || raw === 'uncategorized') {
        return null;
      }
      const n = Number(raw);
      return Number.isFinite(n) && n > 0 ? n : null;
    }
  },
  watch: {
    show(val) {
      if (!val) {
        this.resetShareState();
        return;
      }
      if (this.categoryApiId != null) {
        this.fetchSharing();
      }
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    accessLevelToWorkersKey(level) {
      if (level === 2) {
        return 'edit';
      }
      if (level === 1) {
        return 'view';
      }
      return 'none';
    },
    workersKeyToAccessLevel(key) {
      if (key === 'edit') {
        return 2;
      }
      if (key === 'view') {
        return 1;
      }
      return 0;
    },
    async fetchSharing() {
      const id = this.categoryApiId;
      if (id == null) {
        return;
      }
      this.isSharingLoading = true;
      try {
        const r = await axios.get(`/api/tags/categories/${id}/sharing`);
        if (!this.show) {
          return;
        }
        const d = r && r.data ? r.data : {};
        const users = Array.isArray(d.users) ? d.users : [];
        const general = d.general_access_level;
        this.sharedTeachers = users.map(u => ({
          userId: u.user_id,
          label: [u.name, u.last_name].filter(Boolean).join(' ').trim() || '—',
          image_path: u.image_path || null,
          permission: u.access_level === 2 ? 'edit' : 'view'
        }));
        this.sharingUserIdsInitiallyLoaded = users.map(u => u.user_id);
        this.allWorkersAccess = this.accessLevelToWorkersKey(
          Number(general) || 0
        );
      } catch (e) {
        if (!this.show) {
          return;
        }
        this.sharedTeachers = [];
        this.sharingUserIdsInitiallyLoaded = [];
        this.allWorkersAccess = 'none';
        this.$toastr && this.$toastr.e && this.$toastr.e('שגיאה בטעינת השיתוף');
      } finally {
        this.isSharingLoading = false;
      }
    },
    buildSharingPatchBody() {
      const usersPayload = [];
      const currentIds = new Set(this.sharedTeachers.map(r => r.userId));
      for (const uid of this.sharingUserIdsInitiallyLoaded) {
        if (!currentIds.has(uid)) {
          usersPayload.push({ user_id: uid, access_level: 0 });
        }
      }
      for (const row of this.sharedTeachers) {
        usersPayload.push({
          user_id: row.userId,
          access_level: this.workersKeyToAccessLevel(row.permission)
        });
      }
      return {
        users: usersPayload,
        general_access_level: this.workersKeyToAccessLevel(
          this.allWorkersAccess
        )
      };
    },
    async onSaveShare() {
      const id = this.categoryApiId;
      if (id == null || this.isSavingShare) {
        return;
      }
      this.isSavingShare = true;
      try {
        await axios.patch(
          `/api/tags/categories/${id}/sharing`,
          this.buildSharingPatchBody()
        );
        if (!this.show) {
          return;
        }
        this.$toastr && this.$toastr.s && this.$toastr.s('נשמר');
        this.$emit('saved');
        this.onClose();
      } catch (e) {
        this.$toastr && this.$toastr.e && this.$toastr.e('שגיאה בשמירת השיתוף');
      } finally {
        this.isSavingShare = false;
      }
    },
    resetShareState() {
      this.selectedWorkerUserId = null;
      this.sharedTeachers = [];
      this.sharingUserIdsInitiallyLoaded = [];
      this.permMenuOpenUserId = null;
      this.allWorkersAccess = 'none';
      this.isSharingLoading = false;
      this.isSavingShare = false;
    },
    permissionLabel(perm) {
      return perm === 'edit' ? 'עריכה' : 'צפייה';
    },
    togglePermMenu(userId) {
      if (this.permMenuOpenUserId === userId) {
        this.permMenuOpenUserId = null;
        return;
      }
      this.permMenuOpenUserId = userId;
    },
    closePermMenu() {
      this.permMenuOpenUserId = null;
    },
    pickPermission(userId, perm) {
      this.setPermission(userId, perm);
      this.permMenuOpenUserId = null;
    },
    onWorkerPicked(payload) {
      if (!payload || payload.userId == null) {
        return;
      }
      const uid = payload.userId;
      if (this.currentUser && uid === this.currentUser.id) {
        this.selectedWorkerUserId = null;
        return;
      }
      if (this.sharedTeachers.some(r => r.userId === uid)) {
        this.selectedWorkerUserId = null;
        return;
      }
      this.sharedTeachers.push({
        userId: uid,
        label: payload.label || '—',
        image_path: payload.image_path || null,
        permission: 'view'
      });
      this.selectedWorkerUserId = null;
    },
    setPermission(userId, perm) {
      const row = this.sharedTeachers.find(r => r.userId === userId);
      if (row) {
        this.$set(row, 'permission', perm);
      }
    },
    removeShared(userId) {
      this.sharedTeachers = this.sharedTeachers.filter(
        r => r.userId !== userId
      );
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .custom-select .vue-treeselect__placeholder {
  top: 8px !important;
}
::v-deep .custom-select .vue-treeselect__single-value {
  padding-top: 2px !important;
}
.tags-category-share-modal__title {
  font-weight: 600;
  padding-bottom: 30px;
  line-height: 1.3;
  color: #38455d;
}
.tags-category-share-modal__title-modal {
  font-size: 24px;
  font-weight: 600;

  line-height: 1.3;
  color: #38455d;
}
.tags-category-share-modal__toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  direction: rtl;
}
.tags-category-share-modal__toolbar-title {
  font-size: 20px;
  font-weight: 600;
  color: #38455d;
}
.tags-category-share-modal__sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #38455d;
  text-align: right;
  padding-top: 8px;
}
.tags-category-share-modal__counter {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  border-radius: 999px;
  background: #eef2f8;
  font-size: 14px;
  font-weight: 600;
  color: #5a6f95;
}
.tags-category-share-modal__members {
  margin-top: 16px;
  min-height: 100px;
  max-height: 260px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  direction: rtl;
}
.tags-category-share-modal__member {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  background: #f7f8fa;
  border-radius: 12px;
  height: 48px;
}
.tags-category-share-modal__member--owner {
  border-color: #e3ecf8;
}
.tags-category-share-modal__member-main {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1;
}
.tags-category-share-modal__avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.tags-category-share-modal__avatar--empty {
  background: #e9eef7;
}
.tags-category-share-modal__name {
  font-size: 14px;
  font-weight: 600;
  color: #38455d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tags-category-share-modal__owner-badge {
  font-size: 13px;
  font-weight: 400;
  color: #5a6f95;
  flex-shrink: 0;
}
.tags-category-share-modal__member-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.tags-category-share-modal__perm {
  position: relative;
  z-index: 1;
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  flex-shrink: 0;
}
.tags-category-share-modal__perm--open {
  z-index: 20;
}
.tags-category-share-modal__perm-trigger {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  margin: 0;
  padding: 2px 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  font: inherit;
  text-align: right;
}
.tags-category-share-modal__perm-trigger:focus {
  outline: none;
}
.tags-category-share-modal__perm-trigger:focus-visible {
  box-shadow: 0 0 0 2px rgba(64, 159, 255, 0.35);
  border-radius: 4px;
}
.tags-category-share-modal__perm-trigger-text {
  color: #5b7299;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.3;
}
.tags-category-share-modal__perm-chevron {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}
.tags-category-share-modal__perm-chevron--open {
  transform: scaleY(-1);
}
.tags-category-share-modal__perm-panel {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  min-width: 140px;
  padding: 6px;
  background: #fff;
  border: 1px solid #e3e7ee;
  border-radius: 10px;
  box-shadow: 0 8px 20px -4px rgba(56, 69, 93, 0.12),
    0 4px 12px -4px rgba(56, 69, 93, 0.08);
}
.tags-category-share-modal__perm-option {
  display: block;
  width: 100%;
  margin: 0;
  padding: 10px 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  text-align: right;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.35;
  color: #38455d;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.tags-category-share-modal__perm-option:hover {
  background: #eef7ff;
  color: #1a2b4a;
}
.tags-category-share-modal__perm-option--active {
  color: #409fff;
  background: #f0f7ff;
}
.tags-category-share-modal__perm-option
  + .tags-category-share-modal__perm-option {
  margin-top: 2px;
}
.tags-category-share-modal__remove {
  border: 0;
  padding: 4px;
  margin: 0;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.tags-category-share-modal__remove:hover {
  opacity: 0.85;
}

.tags-category-share-modal__all-workers {
  margin-top: 20px;
  direction: rtl;
}
.tags-category-share-modal__all-workers-title {
  font-size: 20px;
  font-weight: 600;
  color: #38455d;
  text-align: right;
  margin-bottom: 10px;
  line-height: 1.3;
}
.tags-category-share-modal__all-workers-bar {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex-wrap: nowrap;
  gap: 4px;
  padding: 4px;
  background: #eef1f6;
  border-radius: 14px;
}
.tags-category-share-modal__all-workers-seg {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  height: 32px;
  padding: 8px 6px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 400;
  color: #38455d;
  transition: background 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease;
}
.tags-category-share-modal__all-workers-seg:hover:not(.tags-category-share-modal__all-workers-seg--active) {
  background: rgba(255, 255, 255, 0.45);
}
.tags-category-share-modal__all-workers-seg--active {
  background: #fff;
  border-color: #e3e7ee;
  box-shadow: 0 1px 3px rgba(56, 69, 93, 0.08);
}
.tags-category-share-modal__all-workers-seg span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tags-category-share-modal__all-workers-icon {
  flex-shrink: 0;
  color: #5a6f95;
}
.tags-category-share-modal__all-workers-seg--active
  .tags-category-share-modal__all-workers-icon {
  color: #38455d;
}

.tags-category-share-modal__footer {
  position: absolute;
  width: 100%;
  bottom: 6px;
}
.tags-category-share-modal__save {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 93%;
  /* min-height: 48px; */
  height: 40px;
  /* padding: 12px 16px; */
  border: none;
  border-radius: 12px;
  background: #29cc44;
  color: #fff;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  cursor: pointer;
  transition: background 0.15s ease, box-shadow 0.15s ease;
}
.tags-category-share-modal__save:hover {
  background: #24b83c;
}
.tags-category-share-modal__save:active {
  background: #1da834;
}
.tags-category-share-modal__save:focus {
  outline: none;
}
.tags-category-share-modal__save:focus-visible {
  box-shadow: 0 0 0 3px rgba(41, 204, 68, 0.35);
}
.tags-category-share-modal__save:disabled {
  background: #e3e7ee;
  color: #8e9ebb;
  cursor: not-allowed;
  pointer-events: none;
}
.tags-category-share-modal__save-text {
  flex-shrink: 0;
}
.tags-category-share-modal__save-disk {
  flex-shrink: 0;
  color: #fff;
}
</style>
